// External Dependencies
import PropTypes from 'prop-types';
import React from 'react';
import { TableFooter, TablePagination, TableRow } from 'material-ui-next/Table';

// Inernal Dependencies
import connectComponent from '../../connect-component';
import { updatePage, updateRowsPerPage } from '../../state/ui/update-ninjas/actions/actions';

// Local Variables
const propTypes = {
  coders: PropTypes.arrayOf(PropTypes.object).isRequired,
  onUpdatePage: PropTypes.func.isRequired,
  onUpdateRowsPerPage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const defaultProps = {
  coders: [],
  onUpdatePage: null,
  onUpdateRowsPerPage: null,
  pageNumber: 0,
  rowsPerPage: 10,
};

// Component Definition
const NinjasTableFooter = (props) => {
  const {
    coders,
    onUpdatePage,
    onUpdateRowsPerPage,
    pageNumber,
    rowsPerPage,
  } = props;

  const handleChangePage = (event, page) => {
    onUpdatePage(page);
  };

  const handleChangeRowsPerPage = (event) => {
    onUpdateRowsPerPage(event.target.value);
  };

  return (
    <TableFooter>
      <TableRow>
        <TablePagination
          colSpan={6}
          count={coders.length}
          rowsPerPage={rowsPerPage}
          page={pageNumber}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </TableRow>
    </TableFooter>
  );
};

NinjasTableFooter.propTypes = propTypes;
NinjasTableFooter.defaultProps = defaultProps;
export default connectComponent((state) => {
  const { coders, ui } = state;
  const { pageNumber, rowsPerPage } = ui.updateNinjas;
  return {
    coders,
    pageNumber,
    rowsPerPage,
  };
}, {
  onUpdatePage: updatePage,
  onUpdateRowsPerPage: updateRowsPerPage,
}, NinjasTableFooter);



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/ninjas-table-footer.js
 **/